const styles: Record<string, string> = {
    canvas: `
        :host {
            font-family: 'Onesize', 'Courier New', monospace;
            width: 100%;
            max-width: 100%;
            height: 100%;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: auto auto 1fr auto;
            gap: 10px;
            padding: 10px;

            box-sizing: border-box;
        }

        @media (min-width: 768px) {
            :host {
                grid-template-columns: minmax(300px, 30%) 1fr;
                grid-template-rows: auto 1fr auto;
                grid-template-areas:
                    "title title"
                    "chat-box main-content"
                    "footer footer";
            }
            
            .title {
                grid-area: title;
            }
            
            .chat-box {
                grid-area: chat-box;
            }
            
            .main-content {
                grid-area: main-content;
            }
            
            .footer {
                grid-area: footer;
            }
        }

        h1, h2, h3, h4, h5, h6 {
            margin: 0;
            font-family: 'Onesize', 'Courier New', monospace;
        }

        p, button, a, div {
            font-family: 'Onesize', 'Courier New', monospace;
            margin: 0;
        }

        .title {
            text-align: center;
            margin-bottom: 15px;
            font-size: 2.5em;
            text-transform: uppercase;
            letter-spacing: 3px;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
            color: rgb(196, 105, 30);
        }

        .left-column-container {
            display: flex;
            flex-direction: column;
            gap: 10px;
            width: 100%;
            height: 100%;
        }

        .chat-box {
            background-color: #1a1a1a;
            border: 2px solid #444;
            padding: 15px;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            gap: 10px;
            height: 100%;
        }

        .room-name {
            font-size: 1.5em;
            margin-bottom: 10px;
            border-bottom: 2px solid #444;
            padding-bottom: 10px;
        }

        .main-content {
            display: flex;
            flex-direction: column;
            gap: 15px;
        }

        .room-image-container {
            width: 100%;
            height: 100%;
            text-align: center;
            position: relative;

            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            background-color: #1a1a1a;
            padding-block: 10px;
            border: 2px solid #444;
            box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
        }

        .room-image-layer {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        .room-image {
            max-width: 100%;
            max-height: 40vh;
            border-radius: 5px;
            box-shadow: 0 0 10px rgba(0,0,0,0.5);
        }

        .room-name {
            font-size: 1.5em;
            margin-bottom: 10px;
        }

        .achievement-small-popup {
            background-color: #1e2a3a;
            padding: 8px;
            position: absolute;
            top: 20px;
            right: 20px;
            z-index: 9999;
        }

        .header {
            background-color: #1a1a1a;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            margin-top: 20px;
            border: 2px solid #444;
            box-shadow: 0 0 15px rgba(0,0,0,0.5);
        }

        .footer {
            margin-top: 15px;
        } 

        .player-name-popup {
            background-color: #222;
            padding: 20px;
            border-radius: 12px;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.7);
            color: #ddd;
            text-align: center;
            width: 90%;
            animation: popup-appear 0.3s ease-out;
        }

        .player-name-popup p {
            font-size: 16px;
            margin-bottom: 10px;
        }

        #player-name-input {
            width: 90%;
            padding: 10px;
            border: 1px solid #555;
            border-radius: 5px;
            background-color: #333;
            color: #ddd;
            font-size: 14px;
            outline: none;
        }

        #player-name-input::placeholder {
            color: #aaa;
        }

        #player-name-submit {
            margin-top: 10px;
            padding: 10px 15px;
            background-color: #4a90e2;
            color: white;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            font-weight: bold;
            transition: background-color 0.2s ease;
        }

        #player-name-submit:hover {
            background-color: #357ab8;
        }
    `,
    achievement: `
        .achievement-grid {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1rem;
            padding: 1rem;
            background-color: #f5f5f5;
            border-radius: 12px;
            max-width: 1200px;
            margin: 0 auto;
        }

        .layer-navigation {
            display: flex;
            gap: 0.5rem;
            justify-content: center;
        }

        .layer-navigation button {
            padding: 0.5rem 1rem;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            background-color: #4a90e2;
            color: white;
            transition: background-color 0.2s ease;
        }

        .layer-navigation button:hover {
            background-color: #357ab8;
        }

        .achievement-content {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            justify-content: center;
        }

        .achievement-layer {
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            justify-content: center;
        }

        .achievement-item {
            background-color: #333;
            border: 1px solid #555;
            border-radius: 5px;
            padding: 10px;
            text-align: center;
            cursor: pointer;
            transition: all 0.2s ease;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            min-height: 150px;
        }

        .achievement-item:hover {
            background-color: #444;
            transform: translateY(-2px);
            box-shadow: 0 5px 10px rgba(0,0,0,0.3);
        }

        .achievement-item img {
            margin-bottom: 10px;
        }

        .achievement-item span {
            color: #ddd;
            font-size: 14px;
        }

        .achievement-timestamp {
            font-size: 10px;
            color: #aaa;
            margin-top: 8px;
            font-style: italic;
        }

        .achievement-item.unachieved {
            filter: grayscale(100%);
            opacity: 0.6;
        }

        .achievement-grid { 
            display: flex;
            flex-direction: column;
            gap: 20px;
            padding: 20px;
            background-color: #222;
            border-radius: 10px;
            border: 2px solid #555;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.7);
            color: #ddd;
        }

        .achievement-popup {
            background-color: #222;
            padding: 20px;
            border-radius: 12px;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.7);
            color: #ddd;
            text-align: center;
            max-width: 300px;
            width: 90%;
            animation: popup-appear 0.3s ease-out;
        }

        .achievement-popup-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background-color: rgba(0, 0, 0, 0.8);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9999;
        }


        .layer-navigation {
            display: flex;
            justify-content: center;
            gap: 10px;
            margin-bottom: 20px;
        }

        .layer-navigation button {
            padding: 10px 20px;
            background-color: #333;
            color: #ddd;
            border: 1px solid #555;
            border-radius: 5px;
            cursor: pointer;
            font-weight: bold;
            transition: all 0.2s ease;
        }

        .layer-navigation button:hover {
            background-color: #555;
            color: #fff;
            transform: translateY(-2px);
        }

        .achievement-content {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
            gap: 20px;
        }

        .achievement-item-row {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .achievement-arrow {
            font-size: 32px;
            color: #aaa;
            transition: transform 0.2s;
        }

        .achievement-item-row:hover .achievement-arrow {
            transform: translateX(4px);
        }

        @keyframes popup-appear {
            from {
                transform: scale(0.8);
                opacity: 0;
            }
            to {
                transform: scale(1);
                opacity: 1;
            }
        }

    `,
    actions: `
        .footer {
            background-color: #1a1a1a;
            padding: 15px;
            border: 2px solid #444;
            box-shadow: 0 0 15px rgba(0,0,0,0.5);
            display: flex;
            flex-direction: column;
            gap: 10px;
            transition: all 0.3s ease;
        }


        .footer[data-started="false"] .restart-button,
        .footer[data-started="false"] .map-button,
        .footer[data-started="false"] .achievement-button {
            opacity: 0;
            pointer-events: none;
            cursor: not-allowed;
        }

        .footer[data-started="false"] .restart-button:hover,
        .footer[data-started="false"] .map-button:hover,
        .footer[data-started="false"] .achievement-button:hover {
            transform: none;
            box-shadow: none;
        }

        .action-buttons {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            justify-content: center;
        }

        .action-button {
            background-color: #333;
            color: #ddd;
            border: 1px solid #555;
            border-radius: 5px;
            padding: 8px 15px;
            cursor: pointer;
            transition: all 0.2s ease;
            font-size: 18px;
        }

        .action-button:hover {
            background-color: #444;
            transform: translateY(-2px);
            box-shadow: 0 5px 10px rgba(0,0,0,0.3);
        }

        .action-button.selected {
            background-color: #553311;
            border-color: #aa6622;
            box-shadow: 0 0 10px rgba(255, 165, 0, 0.5);
        }

        .action-button.disabled {
            background-color: #2a2a2a;
            color: #666;
            border-color: #444;
            cursor: not-allowed;
        }

        .game-controls {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
        }

        .restart-button {
            background-color: #ff6b6b;
            color: #fff;
            border: 1px solid #ff6b6b;
            border-radius: 5px;
            padding: 8px 15px;
            cursor: pointer;
            transition: all 0.2s ease;
        }

        .restart-button:hover {
            background-color: #ff4757;
            transform: translateY(-2px);
            box-shadow: 0 5px 10px rgba(0,0,0,0.3);
        }

        .map-button {
            background-color: #3498db;
            color: #fff;
            border: 1px solid #3498db;
            border-radius: 5px;
            padding: 8px 15px;
            cursor: pointer;
            transition: all 0.2s ease;
        }

        .map-button:hover {
            background-color: #2980b9;
            transform: translateY(-2px);
            box-shadow: 0 5px 10px rgba(0,0,0,0.3);
        } 

        .achievement-button {
            background-color: #3498db;
            color: #fff;
            border: 1px solid #3498db;
            border-radius: 5px;
            padding: 8px 15px;
            cursor: pointer;
            transition: all 0.2s ease;
        }

        .achievement-button:hover {
            background-color: #2980b9;
            transform: translateY(-2px);
            box-shadow: 0 5px 10px rgba(0,0,0,0.3);
        } 
    `,
    inventory: `
        game-inventory {
            height: 100%;
            transition: all 0.3s ease;
        }

        game-inventory[data-started="false"] .inventory {
            background-color: #2a2a2a;
            border-color: #666;
        }

        game-inventory[data-started="false"] .inventory-title {
            color: #888;
        }

        game-inventory[data-started="false"] .inventory-stats {
            color: #666;
        }

        game-inventory[data-started="false"] .stats-count {
            color: #888;
        }

        game-inventory[data-started="false"] .risk-summary-label {
            color: #666;
        }

        game-inventory[data-started="false"] .inventory-item {
            background-color: #2a2a2a;
            border-color: #666;
        }

        game-inventory[data-started="false"] .inventory-item:hover {
            background-color: #333;
        }

        game-inventory[data-started="false"] .inventory-item-name {
            color: #888;
        }

        game-inventory[data-started="false"] .risk-factor-label {
            color: #666;
        }

        .inventory {
            background-color: #1a1a1a;
            border: 2px solid #444;
            box-shadow: 0 0 15px rgba(0,0,0,0.5);
            overflow-y: auto;
            height: 100%;
            padding: 10px;
            box-sizing: border-box;

        }

        .inventory-header {
            margin-bottom: 15px;
        }

        .inventory-title {
            color: #ddd;
            font-size: 1.5em;
            margin-bottom: 10px;
            text-align: center;
            border-bottom: 1px solid #444;
            padding-bottom: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .inventory-stats {
            display: flex;
            align-items: center;
            justify-content: space-around;
            margin-top: 8px;
            font-size: 0.8em;
            color: #aaa;
            gap: 32px;
            width: 100%;
        }

        .stats-count {
            color: #bbb;
        }

        .risk-summary {
            display: flex;
            align-items: center;
            gap: 5px;
        }

        .risk-summary-label {
            color: #aaa;
        }

        .risk-summary-value {
            padding: 2px 6px;
            border-radius: 10px;
            font-weight: bold;
            color: #000;
            text-shadow: 0 0 2px rgba(255, 255, 255, 0.5);
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
            min-width: 30px;
            text-align: center;
        }

        .risk-summary-item {
            color: #ddd;
            font-style: italic;
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .inventory-summary {
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 5px 0;
            background-color: #2a2a2a;
            border-radius: 5px;
            margin-top: 5px;
        }

        .summary-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 5px 10px;
        }

        .summary-label {
            color: #aaa;
            font-size: 0.8em;
            margin-bottom: 3px;
        }

        .summary-value {
            font-weight: bold;
            font-size: 1em;
            padding: 2px 8px;
            border-radius: 10px;
            color: #000;
            text-shadow: 0 0 2px rgba(255, 255, 255, 0.5);
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
        }

        .inventory-items {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
            gap: 10px;
            padding: 10px;
        }

        .inventory-item {
            background-color: #333;
            border: 1px solid #555;
            border-radius: 5px;
            padding: 10px;
            text-align: center;
            cursor: pointer;
            transition: all 0.2s ease;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: auto;
            min-height: 120px;
        }

        .inventory-item:hover {
            background-color: #444;
            transform: translateY(-2px);
            box-shadow: 0 5px 10px rgba(0,0,0,0.3);
        }

        .inventory-item.selected {
            background-color: #553311;
            border-color: #aa6622;
            box-shadow: 0 0 10px rgba(255, 165, 0, 0.5);
        }

        .inventory-item-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            aspect-ratio: 1/1;
        }

        .inventory-item-name {
            color: #ddd;
            font-size: 0.9em;
            margin-top: 5px;
            font-size: 12px;
        }

        .inventory-empty {
            color: #888;
            text-align: center;
            padding: 20px;
            font-style: italic;
        }

        /* Risk Factor Styles */
        .risk-factor-container {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 8px;
            width: 100%;
            gap: 5px;
        }

        .risk-factor-label {
            color: #aaa;
            font-size: 12px;
        }

        .risk-factor-value {
            padding: 2px 6px;
            border-radius: 10px;
            font-weight: bold;
            font-size: 12px;
            color: #000;
            text-shadow: 0 0 2px rgba(255, 255, 255, 0.5);
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
            min-width: 30px;
            text-align: center;
            transition: all 0.3s ease;
        }

        .risk-minimal {
            background-color: rgb(0, 255, 0);
        }

        .risk-low {
            background-color: rgb(128, 255, 0);
        }

        .risk-medium {
            background-color: rgb(255, 255, 0);
        }

        .risk-high {
            background-color: rgb(255, 128, 0);
        }

        .risk-extreme {
            background-color: rgb(255, 0, 0);
        }

        /* Flashing animation for extreme risk */
        @keyframes risk-flash {
            0% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.8; transform: scale(1.1); }
            100% { opacity: 1; transform: scale(1); }
        }

        .risk-flashing {
            animation: risk-flash 0.5s infinite;
            box-shadow: 0 0 10px rgba(255, 0, 0, 0.7);
        } 
    `,
    map: `
        .prison-map-container {
            position: relative;
            width: 700px;
            height: 700px;
            background-color: #1a1a2e;
            overflow: hidden;
            border: 2px solid #16213e;
            border-radius: 8px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
        }

        .prison-map {
            position: relative;
            width: 100%;
            height: 100%;
            background-image: url('/assets/img/rooms/prison-map-bg.png');
            background-blend-mode: darken;
            background-color: rgba(0, 0, 0, 0.4);
            background-size: cover;
            background-position: center;
        }

        .prison-outline {
            position: absolute;
            top: 5px;
            left: 5px;
            right: 5px;
            bottom: 5px;
            border: 2px dashed rgba(255, 255, 255, 0.1);
            border-radius: 6px;
            pointer-events: none;
        }

        .room-shape {
            position: absolute;
            border: 2px solid rgba(255, 255, 255, 0.2);
            background-color: rgba(30, 30, 50, 0.8);
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
            backdrop-filter: blur(2px);
            overflow: hidden;
        }

        .room-shape:hover:not(.locked):not(.not-available-room) {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
        }

        .map-room-name {
            color: rgba(255, 255, 255, 0.9);
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            text-transform: capitalize;
            padding: 5px;
            text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
            transition: all 0.3s ease;
            width: 100%;
            border: none;
        }

        .current {
            background-color: rgba(52, 152, 219, 0.7);
            border-color: #3498db;
            box-shadow: 0 0 15px rgba(52, 152, 219, 0.6);
            z-index: 10;
        }

        .current .room-name {
            color: #ffffff;
            font-weight: 600;
        }

        .current:hover {
            background-color: rgba(52, 152, 219, 0.8);
        }

        .unlocked {
            background-color: rgba(46, 204, 113, 0.6);
            border-color: #2ecc71;
        }

        .unlocked:hover {
            background-color: rgba(46, 204, 113, 0.7);
        }

        .locked {
            background-color: rgba(149, 165, 166, 0.5);
            border-color: #95a5a6;
            cursor: not-allowed;
        }

        .locked .room-name {
            color: rgba(255, 255, 255, 0.6);
        }

        .not-available-room {
            background-color: rgba(30, 30, 30, 0.4);
            border-color: rgba(100, 100, 100, 0.3);
            cursor: not-allowed;
            opacity: 0.7;
        }

        .not-available-room .room-name {
            color: rgba(255, 255, 255, 0.4);
        }

        .map-legend {
            position: absolute;
            bottom: 15px;
            right: 15px;
            background-color: rgba(10, 15, 30, 0.85);
            padding: 12px 15px;
            border-radius: 8px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
            backdrop-filter: blur(5px);
            max-width: 200px;
        }

        .legend-item {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
        }

        .legend-item:last-child {
            margin-bottom: 0;
        }

        .legend-color {
            width: 16px;
            height: 16px;
            margin-right: 12px;
            border-radius: 4px;
            border: 1px solid rgba(255, 255, 255, 0.2);
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
        }

        .legend-color.current {
            background-color: rgba(52, 152, 219, 0.7);
            border-color: #3498db;
        }

        .legend-color.unlocked {
            background-color: rgba(46, 204, 113, 0.6);
            border-color: #2ecc71;
        }

        .legend-color.locked {
            background-color: rgba(149, 165, 166, 0.5);
            border-color: #95a5a6;
        }

        .legend-color.not-available-room {
            background-color: rgba(30, 30, 30, 0.4);
            border-color: rgba(100, 100, 100, 0.3);
        }

        .legend-text {
            color: rgba(255, 255, 255, 0.85);
            font-size: 0.85em;
            font-weight: 500;
        } 
    `,
    popups: `
        .popup-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.7);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
        }

        .popup {
            background-color: #222;
            border: 2px solid #555;
            border-radius: 8px;
            padding: 20px;
            max-width: 80%;
            max-height: 80%;
            overflow-y: auto;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
            position: relative;
            padding-top: 50px;
        }

        .popup-close {
            position: absolute;
            top: 10px;
            right: 10px;
            background-color: #333;
            color: #ddd;
            border: 1px solid #555;
            border-radius: 50%;
            width: 30px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            font-size: 1.2em;
            transition: all 0.2s ease;
            z-index: 1001;
        }

        .popup-close:hover {
            background-color: #555;
            color: #fff;
        }

        .popup-content {
            color: #ddd;
        }

        .restart-confirmation h3 {
            color: #ff6b6b;
            text-align: center;
            margin-bottom: 15px;
        }

        .restart-confirmation p {
            color: #ddd;
            text-align: center;
            margin-bottom: 20px;
        }

        .restart-buttons {
            display: flex;
            justify-content: center;
            gap: 15px;
        }

        .restart-confirm-button, .restart-cancel-button {
            padding: 10px 20px;
            border-radius: 5px;
            cursor: pointer;
            font-weight: bold;
            transition: all 0.2s ease;
        }

        .restart-confirm-button {
            background-color: #ff6b6b;
            color: #fff;
            border: 1px solid #ff6b6b;
        }

        .restart-confirm-button:hover {
            background-color: #ff4757;
            transform: translateY(-2px);
        }

        .restart-cancel-button {
            background-color: #333;
            color: #ddd;
            border: 1px solid #555;
        }

        .restart-cancel-button:hover {
            background-color: #444;
            transform: translateY(-2px);
        }

        /* Item Popup Styles */
        .item-popup-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 15px;
            padding: 10px;
        }

        .item-popup-title {
            color: #fff;
            font-size: 1.8em;
            text-align: center;
            margin: 0;
            padding-bottom: 10px;
            border-bottom: 1px solid #444;
            width: 100%;
        }

        .item-popup-image-container {
            width: 100%;
            display: flex;
            justify-content: center;
            margin: 10px 0;
        }

        .item-popup-image {
            max-width: 200px;
            max-height: 200px;
            object-fit: contain;
            border: 2px solid #444;
            border-radius: 5px;
            background-color: #333;
            padding: 10px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        }

        .item-popup-details {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 15px;
        }

        .item-popup-risk {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 10px;
            background-color: #333;
            border-radius: 5px;
        }

        .item-popup-risk-label {
            font-weight: bold;
            color: #ddd;
        }

        .item-popup-risk-value {
            padding: 5px 10px;
            border-radius: 15px;
            font-weight: bold;
            color: #000;
            text-shadow: 0 0 2px rgba(255, 255, 255, 0.5);
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
            min-width: 40px;
            text-align: center;
        }

        .item-popup-description {
            background-color: #333;
            padding: 15px;
            border-radius: 5px;
            color: #ddd;
            line-height: 1.5;
            font-style: italic;
        }

        /* Reuse the risk factor classes from inventory.css */
        .item-popup-risk-value.risk-minimal {
            background-color: rgb(0, 255, 0);
        }

        .item-popup-risk-value.risk-low {
            background-color: rgb(128, 255, 0);
        }

        .item-popup-risk-value.risk-medium {
            background-color: rgb(255, 255, 0);
        }

        .item-popup-risk-value.risk-high {
            background-color: rgb(255, 128, 0);
        }

        .item-popup-risk-value.risk-extreme {
            background-color: rgb(255, 0, 0);
        }

        /* Flashing animation for extreme risk */
        @keyframes popup-risk-flash {
            0% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.8; transform: scale(1.1); }
            100% { opacity: 1; transform: scale(1); }
        }

        .item-popup-risk-value.risk-flashing {
            animation: popup-risk-flash 0.5s infinite;
            box-shadow: 0 0 10px rgba(255, 0, 0, 0.7);
        }

        /* Enhanced popup risk factor styles */
        .popup-risk-factor {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-top: 10px;
        }

        .popup-risk-factor .risk-factor-value {
            padding: 3px 8px;
            border-radius: 10px;
            font-weight: bold;
            color: #000;
            text-shadow: 0 0 2px rgba(255, 255, 255, 0.5);
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
            min-width: 30px;
            text-align: center;
        }

        /* Reuse the risk factor classes */
        .popup-risk-factor .risk-minimal {
            background-color: rgb(0, 255, 0);
        }

        .popup-risk-factor .risk-low {
            background-color: rgb(128, 255, 0);
        }

        .popup-risk-factor .risk-medium {
            background-color: rgb(255, 255, 0);
        }

        .popup-risk-factor .risk-high {
            background-color: rgb(255, 128, 0);
        }

        .popup-risk-factor .risk-extreme {
            background-color: rgb(255, 0, 0);
        }

        /* Flashing animation for extreme risk */
        @keyframes popup-risk-flash {
            0% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.8; transform: scale(1.1); }
            100% { opacity: 1; transform: scale(1); }
        }

        .popup-risk-factor .risk-flashing {
            animation: popup-risk-flash 0.5s infinite;
            box-shadow: 0 0 10px rgba(255, 0, 0, 0.7);
        }

        /* Enhance popup item details */
        .popup-item-details {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 15px;
            padding-bottom: 15px;
            border-bottom: 1px solid #444;
        }

        .popup-item-details h3 {
            margin: 10px 0 5px 0;
            color: #fff;
            text-align: center;
        }

        .popup-item-image {
            max-width: 200px;
            max-height: 200px;
            object-fit: contain;
            border: 2px solid #444;
            border-radius: 5px;
            background-color: #333;
            padding: 10px;
            margin-bottom: 10px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        } 
    `,
    risk: `
        game-risk-bar{
            display: flex;
            flex-direction: column;
            height: fit-content;
            width: 100%;
            background-color: #1a1a1a;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
            border: 2px solid #444;
            padding: 16px 16px;
            box-sizing: border-box;
            transition: all 0.3s ease;
        }

        /* Inactive state */
        game-risk-bar[data-started="false"] {
            background-color: #2a2a2a;
            border-color: #666;
        }

        game-risk-bar[data-started="false"] .risk-bar {
            background: linear-gradient(to right, 
                #666 0%, 
                #888 20%, 
                #999 40%, 
                #aaa 60%, 
                #bbb 80%
            );
        }

        game-risk-bar[data-started="false"] .risk-timer {
            color: #888;
        }

        game-risk-bar[data-started="false"] .risk-info {
            color: #666;
        }

        game-risk-bar[data-started="false"] .risk-info-value {
            color: #888;
        }

        /* Active state */
        game-risk-bar[data-started="true"] {
            opacity: 1;
            background-color: #1a1a1a;
            border-color: #444;
        }

        .risk-bar-container {
            width: 100%;
            height: 30px;
            background-color: #222;
            border-radius: 15px;
            overflow: hidden;
            margin: 10px 0;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
            border: 1px solid #444;
        }

        .risk-bar {
            height: 100%;
            transition: width 0.3s ease-out;
            background: linear-gradient(to right, 
                #ff0000 0%, 
                #ff5500 20%, 
                #ffaa00 40%, 
                #aacc00 60%, 
                #00cc00 80%
            );
            background-size: 500% 100%;
            box-shadow: 0 0 10px rgba(255, 255, 255, 0.1) inset;
        }

        .risk-timer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-family: 'Courier New', monospace;
            font-weight: bold;
            margin-bottom: 8px;
            color: #ddd;
        }

        .risk-timer-label {
            text-transform: uppercase;
            letter-spacing: 1px;
            text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
        }

        .risk-timer-time {
            padding: 3px 8px;
            background-color: #333;
            border-radius: 4px;
            border: 1px solid #444;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        }

        .risk-info {
            display: flex;
            justify-content: space-between;
            margin-top: 8px;
            font-size: 12px;
            color: #aaa;
        }

        .risk-info-stat {
            display: flex;
            align-items: center;
            gap: 4px;
        }

        .risk-info-value {
            font-weight: bold;
            color: #ddd;
            text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
        }

        .risk-flashing {
            animation: risk-flash 0.7s linear infinite;
        }

        @keyframes risk-flash {
            0% { opacity: 1; }
            50% { opacity: 0.6; }
            100% { opacity: 1; }
        }

        /* Adjust the background position based on risk level */
        .risk-level-100 { background-position: 100% 0; }
        .risk-level-90 { background-position: 90% 0; }
        .risk-level-80 { background-position: 80% 0; }
        .risk-level-70 { background-position: 70% 0; }
        .risk-level-60 { background-position: 60% 0; }
        .risk-level-50 { background-position: 50% 0; }
        .risk-level-40 { background-position: 40% 0; }
        .risk-level-30 { background-position: 30% 0; }
        .risk-level-20 { background-position: 20% 0; }
        .risk-level-10 { background-position: 10% 0; }
        .risk-level-0 { background-position: 0% 0; } 
    `,
    rooms: `
        .rooms {
            background-color: #1a1a1a;
            padding: 10px;
            border: 2px solid #444;
            box-shadow: 0 0 15px rgba(0,0,0,0.5);
            overflow-y: auto;
        }

        .rooms-title {
            color: #ddd;
            font-size: 1.5em;
            margin-bottom: 10px;
            text-align: center;
            border-bottom: 1px solid #444;
            padding-bottom: 5px;
        }

        .room-objects {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
            gap: 10px;
            padding: 10px;
        }

        .room-object {
            background-color: #333;
            border: 1px solid #555;
            border-radius: 5px;
            padding: 10px;
            text-align: center;
            cursor: pointer;
            transition: all 0.2s ease;
        }

        .room-object:hover {
            background-color: #444;
            transform: translateY(-2px);
            box-shadow: 0 5px 10px rgba(0,0,0,0.3);
        }

        .room-object.selected {
            background-color: #553311;
            border-color: #aa6622;
            box-shadow: 0 0 10px rgba(255, 165, 0, 0.5);
        }

        .room-object-name {
            color: #ddd;
            font-size: 0.9em;
            margin-top: 5px;
        }

        .room-empty {
            color: #888;
            text-align: center;
            padding: 20px;
            font-style: italic;
        } 
    `,
    travel: `
        .travel-container {
            background-color: #1e2a3a;
            padding: 15px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
            border: 1px solid #2c3e50;
        }

        .travel-title {
            color: #ecf0f1;
            font-size: 1.1em;
            margin: 0 0 10px 0;
            padding-bottom: 8px;
            border-bottom: 1px solid #34495e;
            display: flex;
            align-items: center;
        }

        .travel-title::before {
            content: "🏢";
            margin-right: 8px;
            font-size: 1.2em;
        }

        .travel-buttons {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            justify-content: flex-start;
        }

        .travel-button {
            background: linear-gradient(to bottom, #3498db, #2980b9);
            color: #fff;
            border: none;
            border-radius: 5px;
            padding: 10px 16px;
            cursor: pointer;
            transition: all 0.3s ease;
            font-size: 16px;
            display: flex;
            align-items: center;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }

        .travel-button::after {
            content: ">";
            margin-left: 6px;
            font-weight: bold;
        }

        .travel-button:hover {
            background: linear-gradient(to bottom, #2980b9, #2471a3);
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
        }

        .travel-button.selected {
            background: linear-gradient(to bottom, #27ae60, #2ecc71);
            box-shadow: 0 0 8px rgba(46, 204, 113, 0.6);
        }

        .travel-button.selected::before {
            content: "✓";
        }

        .no-travel-options {
            color: #95a5a6;
            font-style: italic;
            padding: 5px 0;
        }

        @media (max-width: 768px) {
            .travel-buttons {
                justify-content: center;
            }
            
            .travel-button {
                padding: 12px 18px;
                font-size: 1em;
            }
        } 
    `,
};

export default styles;
